<script setup lang="ts"></script>

<template>
  <!-- 面包屑当前按设计不展示，原结构注释保留；保留一个根节点以满足 vue/valid-template-root -->
  <div />
  <!-- <t-breadcrumb :style="{ margin: '24px 36px' }">
    <t-breadcrumb-item>Home</t-breadcrumb-item>
    <t-breadcrumb-item>DidaOJ</t-breadcrumb-item>
  </t-breadcrumb> -->
</template>

<style scoped></style>
